export const si = {
    //නාවික තීරුව
    'n1': 'මුල් පිටුව',
    'n2': 'ඇණවුම්',
    'n3': 'ගනුදෙනු',
    'n4': 'කණ්ඩායම',
    'n5': 'මගේ',
    //ඉඟි
    't1': 'දෝෂයක් සිදු විය',
    't2': 'පිටපත් කිරීම සාර්ථකයි',
    't3': 'කරුණාකර තොරතුරු සම්පුර්ණයෙන් පුරවන්න',
    't4': 'පූරණය වෙමින්…',
    't5': 'පිවිසුම සාර්ථකයි',
    't6': 'ඉදිරිපත් කිරීමට ශ්‍රේණිගත කිරීම 3ට වඩා වැඩි විය යුතුය',
    't7': 'ඉදිරිපත් කිරීම සාර්ථකයි',
    't8': 'ශේෂය ප්‍රමාණවත් නොවේ, ලබා ගත නොහැක',
    't9': 'ඉදිරිපත් කිරීම අසාර්ථකයි',
    't10': 'කරුණාකර පළමුව මුදල් ආපසු ගැනීමේ ලිපිනය බැඳින්න',
    't11': 'ලිපිනය බැඳී ඇත, වෙනස් කිරීමට පාරිභෝගික සේවාව අමතන්න',
    't12': 'වෙනස් කිරීම සාර්ථකයි',
    't13': 'වෙනස් කිරීම අසාර්ථකයි',
    't14': 'මුරපදය වෙනස් කිරීමට පාරිභෝගික සේවාව අමතන්න',
    't15': 'මුරපද ආකෘතිය වැරදිය',
    't16': 'මුදල් ආපසු ගැනීම සාර්ථකයි',
    't17': 'උපරිම ආපසු ගැනීම්',
    't18': 'අවම ආපසු ගැනීම',
    't19': 'මුරපද දෙක නොගැලපේ',
    't20': 'ඉඟිය',
    't21': 'තාවකාලිකව පිවිසිය නොහැක',
    't22': 'මුරපද ආකෘතිය වැරදිය',
    't23': 'ලියාපදිංචිය සාර්ථකයි',
    't24': 'කරුණාකර ප්‍රදේශ කේතය ඇතුළත් කරන්න',
    't25': 'තවත් නැත',
    //පිවිසුම් හා ලියාපදිංචිය
    'l1': 'භාෂාව',
    'l2': 'කරුණාකර ගිණුම ඇතුළත් කරන්න',
    'l3': 'කරුණාකර මුරපදය ඇතුළත් කරන්න',
    'l4': 'මතක තබා ගන්න',
    'l5': 'පිවිසෙන්න',
    'l6': 'ලියාපදිංචි වන්න',
    'l7': 'ගිණුමක් නැත',
    'l8': 'දුරකථන අංකය',
    'l9': 'අන්වර්ථ නාමය',
    'l10': 'මුරපදය',
    'l11': 'මුරපදය තහවුරු කරන්න',
    'l12': 'ආරාධනා කේතය',
    'l13': 'ලියාපදිංචි වන්න',
    'l14': 'දැනටමත් ගිණුමක් ඇත',
    'l15': 'පිවිසෙන්න',
    'l16': 'කරුණාකර ඉලක්කම් 6-16 මුරපදයක් ඇතුළත් කරන්න',

    //උදව්
    'bz1': 'උදව්',
    'bz2': 'නිතර අසන ප්‍රශ්න',
    'bz3': 'ගනුදෙනු නීති',
    'bz4': 'මුදල් ආපසු ගන්නේ කෙසේද',
    'bz5': 'මුදල් එකතු කරන්නේ කෙසේද',
    'bz6': '1.Amazon Review RoBoT යනු කුමක්ද?',
    'bz7': 'Amazon Review RoBoT යනු ලොව පුරා සිටින Amazon Review RoBoT මාර්ගගත වෙළඳසැල් වෙළෙන්දන්ට වැඩි ඇණවුම් අලෙවියක් ලබා ගැනීමට සහ Amazon Review RoBoT මාර්ගගත වෙළඳසැල් වල බ්‍රවුසින් දත්ත වැඩි කිරීමට උපකාර වන අලෙවිකරණ සහ ප්‍රවර්ධන සමාගමකි. අපි Amazon Review RoBoT, වෙළෙන්දන් සහ පාරිභෝගිකයන් අතර ත්‍රෛපාර්ශ්වික ලාභදායී අලෙවිකරණ ප්‍රවර්ධන ආකෘතියක් ස්ථාපිත කිරීමට කැපවී සිටිමු. නවතම P2P බ්ලොක්චේන් තාක්ෂණය සමඟ ඒකාබද්ධව, USDT (TRC20, ERC20) හරහා පාරිභෝගිකයන් සහ වෙළෙන්දන් ඉක්මනින් සම්බන්ධ කරයි. ලියාපදිංචි පරිශීලකයින්ට ඇණවුම් මත කොමිස් ලබා ගත හැකි අතර, වෙළෙන්දන්ට ඔවුන්ගේ ගබඩාවේ අලෙවි දත්ත වැඩි කළ හැක. එය අන්තර්ජාල බ්ලොක්චේන් ආකෘතියේ නවතම ලාභ ආකෘතියයි!',
    'bz8': '2.Amazon Review RoBoT ක්‍රියා කරන්නේ කෙසේද?',
    'bz9': 'Amazon Review RoBoT හි දෛනික ප්‍රතිපෝෂණයෙන් පෙන්නුම් කරන්නේ Amazon Review RoBoT හි විකුණනු ලබන වැඩිදියුණු කළ යුතු නිෂ්පාදන, පරිශීලකයින්ට ඇණවුම මත පහසුවෙන් ක්ලික් කිරීමට අවශ්‍ය වන අතර, පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් දායකත්වයක් ජනනය කරයි. පරිශීලකයින් බ්ලොක්චේන් USDT හරහා ඇණවුම් මුදල ගෙවන අතර දෛනික කොමිස් ලබා ගනී.',
    'bz10': '3.ගනුදෙනු දෙකකදී එකම මුදල් ඒකකයේ මිල වෙනස් වන්නේ ඇයි?',
    'bz11': 'මිල වෙනස්කම් ඇති වන්නේ මුදල් ඒකක නිදහස් සංසරණයට අහිතකර සියලු සාධක නිසාය, ඒවා අතර මුදල් හුවමාරු වේගය, ජාල තත්ත්වයන්, මුදල් ප්‍රවේශ සීමා, විවිධ කලාපවල පුද්ගලයින්ගේ මුදල් පිළිගැනීම, සහ හුවමාරු මඟින් සපයන වෙළඳ යුගල වර්ග, ගනුදෙනු ආදිය ඇතුළත් වේ. එබැවින්, එකම මුදල් ඒකකයට විවිධ ගනුදෙනු වලදී මිල වෙනස්කම් ඇති විය හැක.',
    'bz12': '4.ආයෝජන ලාභය?',
    'bz13': 'ඔබ ලබා ගන්නා නිෂ්පාදන මිල වැඩි වන තරමට, ඔබට ලැබෙන ඇණවුම් ලාභය වැඩි වේ. ඒ සමඟම, Amazon Review RoBoT විශාල කොමිස් ඇණවුම් අහඹු ලෙස බෙදා හරියි.',
    'bz14': 'සෑම දිනකම, පද්ධතිය ස්වයංක්‍රීයව නිෂ්පාදන ඇණවුම් 60ක් පරිශීලකයින්ට ජනනය කර බෙදා හරින අතර, පරිශීලකයින් USDT හරහා එක් එක් ඇණවුම සඳහා ගෙවීම සම්පූර්ණ කර 0.6% ක කොමිස් මුදලක් ලබා ගනී. විශාල කොමිස් ඇණවුම් අහඹු ලෙස පවරනු ලැබේ.',
    'bz15': 'ඇණවුම් 60 කින් පසු USDT ආපසු ගත හැක. (ඇණවුම් 60 ක් සම්පූර්ණ නොකළහොත්, පද්ධතිය දවසේ ඉතිරි ඇණවුම් ප්‍රමාණයට ස්වයංක්‍රීයව නතර වේ)',
    'bz16': 'සෑම ගිණුමක්ම එක් USDT ගිණුමකට පමණක් බැඳිය හැක. දෝෂයක් සිදු වුවහොත්, කරුණාකර පාරිභෝගික සේවාව අමතන්න',
    'bz17': 'දෛනික ඇණවුම් බෙදා හැරීම සම්පූර්ණ කිරීමෙන් පසු, ඔබට සාමාන්‍ය ලෙස මුදල් ආපසු ගත හැක. ආපසු ගැනීම ආරම්භ කිරීමෙන් පැය 24 ක් ඇතුළත මුදල් ලැබෙන අතර, ආපසු ගැනීමේ සීමාවක් නොමැත',
    'bz18': 'මුදල් එකතු කිරීමට පෙර කරුණාකර ඔබගේ ආපසු ගැනීමේ ලිපිනය (TRC-20 සඳහා සහය දක්වයි) USDT ලිපිනය බැඳින්න. ඔබට APP හෝ වෙබ් පිටුවේ මුදල් එකතු කිරීම ක්ලික් කර, ඔබ භාවිතා කරන බ්ලොක්චේන් (TRC-20) තෝරා මුදල් එකතු කළ හැක.',
    'bz19': 'සම්බන්ධිත ගිණුම් අතර අන්‍යෝන්‍ය මුදල් එකතු කිරීම හෝ බැංකු හුවමාරු, විනිමය හුවමාරු වැනි ක්‍රියා තහනම් වේ. මෙම හැසිරීම ද්වේෂසහගත ඇණවුම් ලබා ගැනීමක් ලෙස සැක කෙරෙන අතර, එවැනි හැසිරීම් අනාවරණය වුවහොත් ගිණුම තහනම් කෙරෙනු ඇත',
    //මොඩියුල පෙළ
    //පොදු වචන
    'ty1': 'තහවුරු කරන්න',
    'ty2': 'අවලංගු කරන්න',
    'ty3': 'ඉදිරිපත් කරන්න',
    "ty4": "TRC20 ලිපිනය",
    "ty5": "ERC20 ලිපිනය",
    //මුල් පිටුව
    's1': 'සමුච්චිත ආදායම',
    's2': 'සේවා',
    's3': 'අප ගැන',
    's4': 'උදව්',
    's5': 'හවුල්කරුවන්',
    's6': 'මගේ සේවා',
    //ඇණවුම්
    'd1': 'නිම නොකළ',
    'd2': 'සම්පූර්ණ කළ',
    'd3': 'දත්ත නැත',
    'd4': 'ඇණවුම් අංකය',
    'd5': 'ගනුදෙනු වේලාව',
    'd6': 'මුදල',
    'd7': 'වත්මන් කාර්ය ගණන',
    'd8': 'අපේක්ෂිත ආදායම',
    'd9': 'තවත් අවශ්‍යයි',
    'd10': 'ශ්‍රේණිගත කිරීම',
    //ගනුදෙනු
    'j1': 'ගිණුම් ශේෂය',
    'j2': 'ගනුදෙනු හැඳින්වීම',
    'j3': 'Amazon Review RoBoT සෑම දිනකම Amazon Review RoBoT හි ප්‍රතිපෝෂණය භාවිතා කර Amazon Review RoBoT විසින් විකුණනු ලබන වැඩිදියුණු කළ යුතු නිෂ්පාදන පෙන්වයි. පරිශීලකයින්ට අවශ්‍ය වන්නේ ඇණවුම මත ක්ලික් කිරීම පමණි, පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් අත්සනක් ජනනය කරයි. පරිශීලකයින් USDT බ්ලොක්චේන් හරහා ඇණවුම් මුදල ගෙවන අතර, සෑම අවස්ථාවකදීම 0.6% ට වැඩි කොමිස් මුදලක් ලබා ගත හැකි අතර, පද්ධතිය අහඹු ලෙස විශාල ත්‍යාග ඇණවුම් බෙදා හරියි.',
    'j4': 'ගැලපීම ආරම්භ කරන්න',
    'j5': 'අද ආදායම',
    'j6': 'සම්පූර්ණ කළ ගණන',
    'j7': 'මුළු කාර්ය ගණන',
    //කණ්ඩායම
    'td1': 'ශේෂය',
    'td2': 'කොමිස්',
    'td3': 'ලබා ගන්න',
    'td4': 'මුළු පිරිස',
    'td5': 'පරිශීලක',
    'td6': 'දායකත්වය',
    'td7': 'ප්‍රමාණය',
    'td8': 'තත්ත්වය',
    //පුද්ගලික මධ්‍යස්ථානය
    'g1': 'මුදල් ආපසු ගන්න',
    'g2': 'මුදල් එකතු කරන්න',
    'g3': 'මිතුරන්ට ආරාධනා කරන්න',
    'g4': 'දැන් ආරාධනා කරන්න',
    'g5': 'මිතුරා ලියාපදිංචි වී උපයන සෑම ලාභයකින්ම, ඔබට අනුරූප කොමිස් මුදලක් ලැබෙනු ඇත',
    'g6': 'පුද්ගලික තොරතුරු',
    'g7': 'අරමුදල් විස්තර',
    'g8': 'මුදල් එකතු කිරීමේ වාර්තා',
    'g9': 'මුදල් ආපසු ගැනීමේ වාර්තා',
    'g10': 'භාෂාව',
    'g11': 'නික්මෙන්න',
    'g12': 'නික්මීමට විශ්වාසද',
    //පරිශීලක තොරතුරු
    'yh1': 'පරිශීලක තොරතුරු',
    'yh2': 'වෙනස් කරන්න',
    'yh3': 'සැකසුම්',
    'yh4': 'දුරකථනය',
    'yh6': 'මුල් මුරපදය',
    'yh7': 'නව මුරපදය',
    //විස්තර
    'mx1': 'කොමිස් ලබා ගැනීම',
    'mx2': 'ආදායම',
    'mx3': 'මුදල් ආපසු ගැනීම ප්‍රතික්ෂේප කළා',
    'mx4': 'වේලාව',
    'mx5': 'මුදල් එකතු කිරීම සාර්ථකයි',
    'mx6': 'ප්‍රතික්ෂේප කළා',
    'mx7': 'ක්‍රියාවට නියමිතයි',
    'mx8': 'මුදල් ආපසු ගැනීමේ ලිපිනය',
    'mx9': 'ලබාගත හැකි ශේෂය',
    'mx10': 'සත්‍ය වශයෙන්ම ලැබුණු',
    'mx11': 'කරුණාකර මුදල් ආපසු ගැනීමේ මුදල ඇතුළත් කරන්න',
    //මුදල් එකතු කිරීම
    'cz1': 'තැන්පත් ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතුව 20USDT වේ',
    'cz2': 'පිටපත් කරන්න',
    'cz3': 'නීත්‍යානුකූල මුදල් ඒකක තේරීම',
    'cz4': 'ගෙවීම',
    'cz5': 'තැන්පත් ලිපිනය TRC20-USDT සඳහා පමණක් සහය දක්වයි, අවම තැන්පතුව 20USDT වේ',
    'cz6': 'තැන්පත් ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතුව 20USDT වේ',
    'cz10': 'තැන්පත් ලිපිනය BTC සඳහා පමණක් සහය දක්වයි',
    //ප්‍රදේශය
    'qy1': 'ප්‍රදේශ කේතය',
    //ආරාධනා
    'yq1': 'මිතුරන්ට ආරාධනා කරන්න',
    'yq2': 'ආරාධනා කේතය',
    'yq3': 'මිතුරන්ට ආරාධනා කරන්න, විශාල ආදායමක් භුක්ති විඳින්න ',
    'yq4': ' ආරාධනා කරන්න යන්න',
    // 7.23 එකතු කළ
    "new1": "ගෙවීම් ක්‍රමය",
    "zf1":"මුදල් එකතු කිරීමේ ක්‍රමය",
    "zf2":"කරුණාකර මුදල් එකතු කිරීමේ ක්‍රමය තෝරන්න",
    "zf3":"ගනුදෙනු මුදල් ඒකකය",
    "zf4":"ගනුදෙනු ජාලය",
    "zf5":"ගනුදෙනුවට යන්න",
    "zf6":"පිටපත් කිරීම සාර්ථකයි",
    "zf7":"ගනුදෙනු මුදල් ඒකකය",
    "zf8":"කරුණාකර භාවිතා කරන්න",
    "zf9":"මුදල් එකතු කිරීම සම්පූර්ණ කිරීමට පහත ලිපිනයට මාරු කරන්න.",
    "zf10":"ගනුදෙනු මුදල් වර්ගය",
    "zf11":"පිටපත් කරන්න",
    "zf12":"කරුණාකර ලිපිනය හොඳින් පරීක්ෂා කරන්න, වැරදි ලෙස මාරු කළහොත් ආපසු ලබාගත නොහැක",
    "zf13":"ලැබීමේ වේලාව",
    "zf14":"ආසන්න වශයෙන් විනාඩි 1~5",
    "zf15":"අවම මුදල් එකතු කිරීමේ මුදල",
    // පාරිභෝගික සේවා
    "kf1": "මාර්ගගත පාරිභෝගික සේවා",
    "kf2": "අතින් පාරිභෝගික සේවා මුදල් ආපසු ගැනීම",
    "kf3": "අතින් පාරිභෝගික සේවා මුදල් ආපසු ගැනීම සඳහා මෙතැන ක්ලික් කරන්න",
    "kf4": "අතින් පාරිභෝගික සේවා මුදල් එකතු කිරීම",
    "kf5": "අතින් පාරිභෝගික සේවා මුදල් එකතු කිරීම සඳහා මෙතැන ක්ලික් කරන්න",
    // ගෙවීම් විකල්ප උත්පතන
    "zf16": "බැංකු කාඩ් ගනුදෙනු සඳහා පාරිභෝගික සේවාව අමතන්න",
    "zf17": "පාරිභෝගික සේවාව අමතන්න",
    "a1": "ගබඩා අලෙවිකරණ මධ්‍යස්ථානය",
    "a2": "Amazon Market Robot ගබඩා අලෙවිකරණ මධ්‍යස්ථානය යනු වෙළෙන්දන්ට කෙටි කාලයක් තුළ නිෂ්පාදන අලෙවිය සහ ධනාත්මක සමාලෝචන වේගයෙන් වැඩි කිරීමට උපකාර වන නව කොටසකි, එමඟින් නිෂ්පාදනවල බර වැඩි කර නිරාවරණය තවදුරටත් වැඩි කරයි. පරිශීලකයින් විවිධ කාර්යයන් සම්පූර්ණ කිරීමෙන් වෙළෙන්දන්ට උපකාර කරන අතර ඊට අනුරූප ත්‍යාග ලබා ගනී, එමඟින් දෙපාර්ශ්වයේම ජයග්‍රහණයක් අත්කර ගනී.",
    "a3": "වර්තමානයේ, මෙම පද්ධතියට පරිශීලකයින් මිලියන 30ක් සහ වෙළෙන්දන් මිලියන 5ක් සිටින අතර, දිනකට මෙම වේදිකාවේ ප්‍රවර්ධනය කෙරෙන නිෂ්පාදන ගණන මිලියන 70 දක්වා ළඟා වේ. සමහර වෙළෙන්දන්ගේ නිෂ්පාදන අලෙවිකරණ මධ්‍යස්ථාන පද්ධතියට සම්බන්ධ කිරීමෙන් ගබඩා අලෙවිය 60% කින් වැඩි කර ඇත. අලෙවිකරණ මධ්‍යස්ථාන පද්ධතියේ වේදිකා පරිශීලකයින්ට ඇණවුම මත ක්ලික් කිරීමට පමණක් අවශ්‍ය වන අතර, අලෙවිකරණ මධ්‍යස්ථාන පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් අත්සනක් ජනනය කරයි. පරිශීලකයින් ඇණවුම් මුදල පෙර ගෙවීමෙන් පසු අතථ්‍ය ගනුදෙනුව සම්පූර්ණ කරයි, අරමුදල් වහාම පරිශීලක ගිණුමට ආපසු ලැබේ. සෑම අවස්ථාවකදීම අමතර 0.6% ට වැඩි කොමිස් මුදලක් ලබා ගත හැකි අතර, පද්ධතිය පරිශීලක කොමිස් වැඩි කිරීමට අහඹු ලෙස විශාල ත්‍යාග ඇණවුම් ද පවරනු ඇත.",
    "a4": "Amazon Market Robot පරිශීලකයින්ගේ සහ වෙළෙන්දන්ගේ අවශ්‍යතා සඳහා විශාල වැදගත්කමක් ලබා දෙන අතර අලෙවිකරණ මධ්‍යස්ථාන පද්ධතිය අඛණ්ඩව ප්‍රශස්තකරණය කර වැඩිදියුණු කරයි."
}
